import React from 'react';
import { RenderChildComponents } from '../List/overrides';
import { IDummyProps } from './types';
import * as meta from '../../meta-data.json';
import { popoverArrow, popoverStyle, popoverInnerStyle, popOverBodyStyle } from './styles';

export const popoverOverrides = {
	Body: {
		style: () => ({
			...popOverBodyStyle(),
			...popoverStyle(),
			width: 'auto',
			height: 'auto',
			backgroundColor: 'var(--epods--color-bg-transparent)',
			overflow: 'visible',
		}),
	},
	Arrow: {
		style: ({ $theme }: any) => {
			return {
				...popoverArrow(),
			};
		},
	},
	Inner: {
		style: ({ $theme }: any) => {
			return {
				...popoverInnerStyle(),
				backgroundColor: 'var(--epods--color-bg-transparent)',
			};
		},
	}
}

export const overrides = ({ props, close, onClickOutside, onCloseList }: { props: IDummyProps, close?: () => void | undefined, onClickOutside?: () => void | undefined, onCloseList?: () => void | undefined }) => {
	const { styleListContainer = {} } = props;

	return {
		List: {
			style: {
				...styleListContainer,
			},
			props: {
				'data-epo': `epo-list-${meta.version}`,
				part: `epo-list-${meta.version}`,
			},
		},
		Option: {
			props: {
				getChildMenu: (item: any) => {
					return item.subList ? (
						<RenderChildComponents
							styleListContainer={styleListContainer}
							close={close}
							size={props.size}
							onItemSelect={props.onItemSelect}
							items={item.subList}
							onClickOutside={onClickOutside}
							onCloseList={onCloseList}
						/>
					) : null;
				},
			},
		},
	};
};


